import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import tippy from 'tippy.js';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

tippy.setDefaultProps({ maxWidth: '' });

document.addEventListener('DOMContentLoaded', () => {
    const timelineWrapper = document.querySelector('.tl-sections');
    const timelineSections = document.querySelectorAll('.tl-section');
    const nav = document.querySelector('.tl-nav');
    const navLinks = document.querySelectorAll('.tl-nav a');

    function updateActiveLink(index) {
        if (!navLinks[index]) return;
        navLinks.forEach((link) => {
            link.classList.remove('active');
        });
        navLinks[index].classList.add('active');
    }

    function showNav() {
        gsap.to(nav, { opacity: 1, pointerEvents: 'auto', duration: 0.3 });
    }

    function hideNav() {
        gsap.to(nav, { opacity: 0, pointerEvents: 'none', duration: 0.3 });
    }

    // Control nav visibility based on .tl-sections wrapper
    ScrollTrigger.create({
        trigger: timelineWrapper,
        start: 'top center',
        end: 'bottom center',
        onEnter: showNav,
        onLeave: hideNav,
        onEnterBack: showNav,
        onLeaveBack: hideNav,
    });

    // Pin each section and update nav on scroll
    timelineSections.forEach((sectionPanel, index) => {
        const link = navLinks[index];
        const trigger = ScrollTrigger.create({
            trigger: sectionPanel,
            start: 'top top',
            end: 'bottom top',
            pin: true,
            pinSpacing: false,
            onEnter: () => updateActiveLink(index + 1),
            onEnterBack: () => updateActiveLink(index),
            // snap: 1,
        });

        // Scroll to section on nav link click
        link.addEventListener('click', (e) => {
            e.preventDefault();
            gsap.to(window, {
                duration: 1,
                scrollTo: trigger.start,
            });
        });

        // Add tooltip to show content from .tooltip-data
        const tooltipContent = sectionPanel?.querySelector('.tooltip-data')?.innerHTML;
        const tooltipButton = sectionPanel?.querySelector('.tooltip-button');
        if (tooltipContent && tooltipButton) {
            tippy(tooltipButton, {
                content: tooltipContent,
                allowHTML: true,
                placement: 'bottom-start',
                interactive: true,
                arrow: false,
                theme: 'cftc',
                popperOptions: {
                    modifiers: [{
                        name: 'flip',
                        enabled: false,
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: [32, -12],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            padding: { right: 36 },
                        },
                    }],
                },
            });
        }
    });

    // Video unmute toggle
    const heroVideo = document.getElementById('cftc-50ans-video');
    const toggleBtn = document.querySelector('.hero-video-toggle');

    if (heroVideo && toggleBtn) {
        function updateToggleButton() {
            const isMuted = heroVideo.muted;
            toggleBtn.setAttribute('aria-pressed', (!isMuted).toString());
            toggleBtn.setAttribute('aria-label', isMuted ? 'Activer le son' : 'Désactiver le son');
            toggleBtn.classList.toggle('is-muted', isMuted);
        }

        toggleBtn.addEventListener('click', () => {
            // Click counts as a user gesture so unmuting is allowed
            heroVideo.muted = !heroVideo.muted;
            if (!heroVideo.muted) {
                heroVideo.volume = 0.6; // sensible default volume on unmute
            }
            updateToggleButton();
        });

        // Support keyboard activation (space/enter)
        toggleBtn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleBtn.click();
            }
        });

        // Initial state
        updateToggleButton();
    }
});
